import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "count"]
  static values = { max: { type: Number, default: 280 } }

  connect() {
    this.update()
  }
  update() {
    const len = (this.textareaTarget.value || "").length
    this.countTarget.textContent = `${len}/${this.maxValue}`
    this.countTarget.classList.toggle("text-red-500", len > this.maxValue)
    this.countTarget.classList.toggle(
      "text-app-text-faint",
      len <= this.maxValue,
    )
  }
}
